import React from 'react';
import { Grid, ImageGroup, Image } from 'semantic-ui-react';
import Media from "react-media";

import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';
import ModalGalleyLayout from './ModalGalleryLayout';

// images
import { galleryThumbnails } from './reducedImages';
import { bothSection } from './imagesSections'

const useRenderAmountOfImage = (nber=undefined, images) => {
  let imagesToRender = images.slice(0);
  if (nber != null && typeof nber === "number") {
    imagesToRender = imagesToRender.slice(0, nber);
  }
  return (
    <ImageGroup size="small" className="imgGalleryGroup">
      { imagesToRender.map((src, index) => {
        return (
          <Image bordered src={src} 
            className="imageGallery"
            key={`bild${index}`} 
          /> 
        );
      })}                       
    </ImageGroup>
  )
};

const RenderImageForFevice = ({ images }) => {
  return (
    <Media query="(max-width: 767px)">
      { (mobile) => (
        <Media query="(max-width: 990px)">
          { (tablet) => (
            <Media query="(max-width: 1300px)">
              { (smallLaptop) => (
                mobile ? useRenderAmountOfImage(4, images ) :
                (!mobile && tablet) ? useRenderAmountOfImage(8, images) :
                (!tablet && smallLaptop) ? useRenderAmountOfImage(6, images) :
                !tablet && !smallLaptop && useRenderAmountOfImage(12, images)
              )}
            </Media>

          )}
        </Media>
      )}
    </Media>
  );
}

const FifthSection = () => {
  return (
    <BasicSectionLayout fluide={true} sectionClasse="galerySection">

      <Grid.Row>

        <Grid.Column computer={6} tablet={14} mobile={16}>

          <SectionHeaderLayout 
                myhr={true}
                title="Gallery"
                headerclass="galeryTitle bigTitle title_gallery-mob"
          >
            <p className="galeryText paragraph padded__text">
              Carefully explore some images of the projects carried out during the training 
              sessions and open days 2017 and 2018. And at the same time immerse yourself in 
              the world of practical workshops of FIPI-Education
            </p>
          </SectionHeaderLayout>

          <div className="centerForMobile">
            <ModalGalleyLayout
              buttonTitle="explore the gallery"
              buttonClass="btnClass btnBackground alignBtn"
              images={bothSection}
            />
          </div>

        </Grid.Column>

        <Grid.Column textAlign="right" 
          computer={6} tablet={14} mobile={16}
          className="columnImage"
        >

          <RenderImageForFevice images={galleryThumbnails} />

        </Grid.Column>

      </Grid.Row>


    </BasicSectionLayout>
  );
}

export default FifthSection;